import React from 'react';
import step01 from '../images/generated-v2/step-01-download.png';
import step02 from '../images/generated-v2/step-02-setup.png';
import step03 from '../images/generated-v2/step-03-sync.png';

const steps = [
  {
    n: '01',
    title: 'Descargá la app',
    img: step01,
    bg: 'from-indigo-50',
    body: 'App Store, Google Play, Windows o macOS. Instala en menos de un minuto. Universal — funciona en cualquier dispositivo.',
  },
  {
    n: '02',
    title: 'Configurá tu empresa',
    img: step02,
    bg: 'from-cyan-50',
    body: (
      <>
        Sube tu certificado <code className="text-[12px] bg-ink-100 px-1.5 py-0.5 rounded text-ink-700">.p12</code>, ingresa tu NIT y giro. Agrega clientes y productos. Listo para emitir.
      </>
    ),
  },
  {
    n: '03',
    title: 'Emití y sincronizá',
    img: step03,
    bg: 'from-violet-50',
    body: 'Crea facturas, CCFs, notas y retenciones. Firma electrónica automática. Sincronización con Hacienda en tiempo real.',
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-ink-50 py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <span className="inline-block text-[11px] font-semibold uppercase tracking-[0.12em] text-brand-600 mb-4">Cómo funciona</span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-ink-950 mb-4 text-balance">
            Tu primera factura, en 5 minutos.
          </h2>
          <p className="text-lg text-ink-500 leading-relaxed">
            Sin instaladores complicados. Sin contadores. Sin enredos con Hacienda.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map(({ n, title, img, bg, body }) => (
            <div key={n} className="bg-white rounded-2xl border border-ink-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <div className={`aspect-[4/3] bg-gradient-to-br ${bg} to-white overflow-hidden`}>
                <img src={img} alt="" aria-hidden="true" className="w-full h-full object-cover" />
              </div>
              <div className="p-7">
                <span className="text-[64px] leading-none font-bold text-ink-100 select-none block mb-3">{n}</span>
                <h3 className="font-bold text-ink-950 text-lg mb-2">{title}</h3>
                <p className="text-ink-500 text-[14px] leading-relaxed">{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
